import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { ActionButtonModule } from '../../../../shared/components/action-button';
import { ReactiveFormInputFieldModule } from '../../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { ForgotPasswordComponent } from './container/forgot-password/forgot-password.component';

@NgModule({
  declarations: [ForgotPasswordComponent, ForgotPasswordFormComponent],
  imports: [
    CommonModule,
    NzIconModule,
    ReactiveFormsModule,
    I18nModule,
    UrlModule,
    RouterModule,
    ReactiveFormInputFieldModule,
    ActionButtonModule,
  ],
  exports: [ForgotPasswordComponent],
})
export class ForgotPasswordModule {}
